module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('accordion-item', {
    attrs: {
      "show-open": ""
    }
  }, [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n        All Heads of Loss\n    ")]), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [(_vm.chosenRates.length === 2) ? _c('span', [_vm._v("\n            Comparison of\n        ")]) : _vm._e(), _vm._v("\n        " + _vm._s(_vm.tableType === 'average' ? 'Average' : 'Total') + " Heads of Loss\n    ")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "p-discount-rate-comparison__chart-select"
  }, [_c('option-filters', {
    attrs: {
      "name": "tableType"
    }
  }, [_c('li', {
    class: {
      'm-option-filters--active': _vm.tableType === 'average'
    },
    on: {
      "click": function($event) {
        return _vm.updateTable('average')
      }
    }
  }, [_vm._v("Average")]), _vm._v(" "), _c('li', {
    class: {
      'm-option-filters--active': _vm.tableType === 'total'
    },
    on: {
      "click": function($event) {
        return _vm.updateTable('total')
      }
    }
  }, [_vm._v("Total")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid u-margin-bottom-20"
  }, [_c('div', {
    staticClass: "u-d-flex u-flex-center u-full-width p-discount-rate-comparison__pie-container"
  }, _vm._l((_vm.chosenRates), function(rate) {
    return _c('pie', {
      attrs: {
        "title": "",
        "rate": rate,
        "labels": _vm.labels,
        "dataset": _vm.dataset(rate),
        "legend": false
      }
    })
  }), 1)]), _vm._v(" "), _c('div', {
    staticClass: "u-text-center"
  }, [_c('chart-legend', {
    attrs: {
      "values": _vm.chartLegend(),
      "legendWidth": _vm.chartLegendWidth,
      "marginTop": "30",
      "marginBottom": "30"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "a-table--short-no-style"
  }, [_c('table', {
    staticClass: "a-table u-full-width"
  }, [_c('tr', [_c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_c('h2', [_vm._v("\n                        Heads of Loss\n                    ")])]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": _vm.numberOfRates
    }
  }, [_c('h2', [_vm._v("\n                        Amount Calculated by Discount Rate\n                    ")])]), _vm._v(" "), (_vm.chosenRates.length === 2) ? _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('h2', [_vm._v("\n                        Difference\n                    ")])]) : _vm._e()]), _vm._v(" "), _c('tr', [_vm._l((_vm.chosenRates), function(rate) {
    return _c('th', [_c('h2', [_vm._v("\n                        " + _vm._s(rate) + "\n                    ")])])
  }), _vm._v(" "), (_vm.chosenRates.length === 2) ? _c('th', [_c('h2', [_vm._v("\n                        £\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.chosenRates.length === 2) ? _c('th', [_c('h2', [_vm._v("\n                        %\n                    ")])]) : _vm._e()], 2), _vm._v(" "), _vm._l((_vm.table()), function(headOfLoss, name) {
    return (headOfLoss != undefined) ? _c('head-of-loss-row', {
      attrs: {
        "name": name,
        "row": headOfLoss
      }
    }) : _vm._e()
  }), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', [_vm._v("\n                        Total\n                    ")]), _vm._v(" "), _vm._l((_vm.chosenRates), function(rate) {
    return _c('td', [_vm._v("\n                        " + _vm._s(_vm.currencyFormat(_vm.sumOf(rate))) + "\n                    ")])
  }), _vm._v(" "), (_vm.chosenRates.length === 2) ? _c('td', [_vm._v("\n                        " + _vm._s(_vm.currencyFormat(_vm.sumOf(_vm.chosenRates[0]) - _vm.sumOf(_vm.chosenRates[1]))) + "\n                        \n                    ")]) : _vm._e(), _vm._v(" "), (_vm.chosenRates.length === 2) ? _c('td', [_vm._v("\n                        " + _vm._s(_vm.roundAndPercent(_vm.sumOf(_vm.chosenRates[0]), _vm.sumOf(_vm.chosenRates[1]))) + "%\n                    ")]) : _vm._e()], 2)])], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-44095292!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/discount-rate-comparison/components/sections/AllHeadsOfLoss.vue
// module id = 1666
// module chunks = 0